import { useState, useEffect, createContext } from "react";
import * as Utils from "../Utils/index";
import { ROLES } from "../Constants/Strings";

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState("");
  const [loading, setLoading] = useState(true);

  const login = (user) => {
    Utils.setUser(user);
    setUser(user);
  };

  const logout = () => {
    Utils.removeCookie("user");
    setUser("");
  };

  const isAdmin = (user?.role === ROLES.ADMIN) ? true : false;

  const values = {
    user,
    setUser,
    login,
    logout,
    isAdmin
  };

  useEffect(() => {
    const fetchUser = async () => {
      const userData = await Utils.getUser();
      setUser(userData);
      setLoading(false);
    };

    fetchUser();
  }, []);

  if (!loading) {
    return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
  }
};

export default UserContextProvider;
